import Vue from "vue";
import Router from "vue-router";
import DashboardLayout from "@/layout/admin/DashboardLayout";
import CustomerPortalLayout from "@/layout/customerPortal/CustomerPortalLayout";
//import AuthLayout from '@/layout/AuthLayout'
import users from "@/assets/images/icon/4.svg";
import activity from "@/assets/images/icon/2.svg";
import inventory from "@/assets/images/icon/3.svg";
import customers from "@/assets/images/icon/5.svg";
import reports from "@/assets/images/icon/6.svg";
import settings from "@/assets/images/icon/7.svg";
import assets from "@/assets/images/icon/8.svg";
import activityCategories from "@/assets/images/icon/9.svg";
import reviews from "@/assets/images/icon/10.svg";
import graphUp from "@/assets/images/icon/graph-up.svg";
import integration from "@/assets/images/icon/6.svg";
import editor from "@/assets/images/icon/6.svg";
import store from "@/store";
import { i18n } from "../translateFunction";

Vue.use(Router);

/* ------------------------------------------------------------ */
let router = new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("../views/Login.vue"),
      meta: { requiresAuth: false, requiresAdmin: false },
    },
    {
      path: "/customer-login",
      name: "customerLogin",
      component: () => import("../views/CustomerLogin.vue"),
      meta: { requiresAuth: false, requiresAdmin: false },
    },
    {
      path: "/forgot_password",
      name: "forgotPassword",
      component: () => import("../views/ForgotPassword.vue"),
      meta: { requiresAuth: false, requiresAdmin: false },
    },
    {
      path: "/customer_forgot_password",
      name: "customerForgotPassword",
      component: () => import("../views/CustomerForgotPassword.vue"),
      meta: { requiresAuth: false, requiresAdmin: false },
    },
    {
      path: "/customer_reset_password",
      name: "customerResetPassword",
      component: () => import("../views/CustomerChangePassword.vue"),
      meta: { requiresAuth: false, requiresAdmin: false },
    },
    {
      path: "/reset_password",
      name: "resetPassword",
      component: () => import("../views/ChangePassword.vue"),
      meta: { requiresAuth: false, requiresAdmin: false },
    },
    {
      path: "/customer_feedback",
      name: "customerFeedback",
      component: () => import("../views/CustomerFeedback.vue"),
      meta: { requiresAuth: false, requiresAdmin: false },
    },
    {
      path: "/pdf_viewer",
      name: "pdfViewer",
      component: () => import("../views/PdfViewer.vue"),
      meta: { requiresAuth: false, requiresAdmin: false },
    },
    {
      path: "/customer-user",
      name: "customerUser",
      component: () => import("../views/CustomerUsers/index.vue"),
      meta: { requiresAuth: false, requiresAdmin: false },
    },
    {
      path: "/customer-portal/",
      name: "customerLayout",
      redirect: "CustomerPortalServiceRequests",
      component: CustomerPortalLayout,
      meta: { requiresAuth: true, requiresAdmin: false },
      children: [
        {
          path: "/customer-portal/profile",
          name: "CustomerProfile",
          component: () => import("@/views/CustomerPortal/CustomerProfile.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: false,
          },
        },
        {
          path: "/customer-portal/service-requests",
          name: "CustomerPortalServiceRequests",
          component: () => import("@/views/CustomerPortal/ServiceRequests.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: false,
          },
        },
        {
          path: "/customer-portal/users",
          name: "CustomerPortalUsers",
          component: () => import("@/views/CustomerPortal/Users.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: false,
          },
        },
        {
          path: "/customer-portal/new-service",
          name: "CustomerPortalNewService",
          component: () =>
            import("@/views/CustomerPortal/CreateServiceRequest.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: false,
          },
        },
        {
          path: "/customer-portal/view-service/:id",
          name: "CustomerPortalViewService",
          component: () =>
            import("@/views/CustomerPortal/ServiceRequestView.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: false,
          },
        },
        {
          path: "/customer-portal/edit-service/:id",
          name: "CustomerPortalEditService",
          component: () =>
            import("@/views/CustomerPortal/EditServiceRequest.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: false,
          },
        },
      ],
    },
    {
      path: "/ams/",
      name: "dashboardLayout",
      redirect: "/ams/dashboard",
      component: DashboardLayout,
      meta: { requiresAuth: true, requiresAdmin: true },
      children: [
        {
          path: "/ams/dashboard",
          name: "dashboard",
          component: () => import("../views/Dashboard.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            displayName: "dashboard",
          },
        },
        {
          path: "/ams/profile",
          name: "profile",
          component: () => import("../views/UserProfile.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            displayName: "profile",
          },
        },
        {
          path: "/ams/users",
          name: "users",
          component: () => import("../views/Users.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "users",
            displayName: "users",
            icon: users,
          },
        },
        {
          path: "/ams/users/:id",
          name: "viewUsers",
          component: () => import("../views/Users/ViewUser.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "users",
            displayName: "users",
          },
        },
        {
          path: "/ams/user-roster",
          name: "userRoster",
          component: () => import("../views/UserRoster/UserRoster.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "users",
            displayName: "user_roster",
            icon: users,
          },
        },
        {
          path: "/ams/user-roster/:id",
          name: "viewUserRoster",
          component: () => import("../views/UserRoster/ViewUserRoster.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "users",
            displayName: "user_roster",
          },
        },

        {
          path: "/ams/activities",
          name: "orders",
          component: () => import("../views/Orders/Orders.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "activity",
            icon: activity,
          },
        },
        {
          path: "/ams/opportunity-status",
          name: "opportunityStatus",
          component: () => import("../views/OpportunityStatus/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "sales_pipeline",
            icon: activity,
          },
        },
       

        {
          path: "/ams/order-asset-rental",
          name: "Asset Rentals",
          component: () => import("../views/Asset_Rentals/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "Asset Rentals",
            icon: activity,
          },
        },
        {
          path: "/ams/activities-assigned-to-others",
          name: "activityAssignedToOthers",
          component: () => import("../views/Orders/Orders.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "activity_assigned_to_others",
            icon: activity,
          },
        },
        {
          path: "/ams/customer-document/:id",
          name: "customerDocument",
          component: () => import("../views/CustomerDocument/ViewDocument.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "customer_document",
            icon: customers,
          },
        },
        {
          path: "/ams/activity-schedule",
          name: "activitySchedule",
          component: () => import("../views/Orders/ActivitySchedule.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "orders",
            displayName: "activity",
          },
        },

        {
          path: "/ams/activities/:id",
          name: "viewOrder",
          component: () => import("../views/Orders/ViewOrder.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "orders",
            displayName: "activity",
          },
        },
        {
          path: "/ams/activity-category",
          name: "activityCategories",
          component: () => import("../views/OrderCategory/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "activity_categories",
            icon: activityCategories,
          },
        },
        {
          path: "/ams/activity-type",
          name: "activity Types",
          component: () => import("../views/OrderType/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "activity_types",
            icon: activity,
          },
        },
        {
          path: "/ams/activity-template",
          name: "activity_templates",
          component: () => import("../views/OrderTemplate/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "activity_templates",
            icon: activityCategories,
          },
        },
        {
          path: "/ams/reviews",
          name: "reviews",
          component: () => import("../views/Checkoffs/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "Activity Review Process",
            icon: reviews,
          },
        },
        {
          path: "/ams/master-bank",
          name: "master bank",
          component: () => import("../views/MasterBank/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "Master Bank",
            icon: activity,
          },
        },


        {
          path: "/ams/document-type",
          name: "DocumentType",
          component: () => import("../views/DocumentType/DocumentType.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "document_type",
            icon: activity,
          },
        },
        {
          path: "/ams/document-type/:id",
          name: "ViewDocumentType",
          component: () => import("../views/DocumentType/ViewDocumentType.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "orders",
            displayName: "document_type",

          },
        },
        {
          path: "/ams/master-document",
          name: "MasterDocument",
          component: () => import("../views/MasterDocument/Document.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "Master Document",
            icon: activity,
          },
        },
        {
          path: "/ams/master-document/:id",
          name: "ViewMasterDocument",
          component: () => import("../views/MasterDocument/ViewDocument.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "orders",
            displayName: "Master Document",

          },
        },
        {
          path: "/ams/payments",
          name: "payment_transaction",
          component: () => import("../views/Payment/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "payments",
            displayName: "payment_transaction",
            icon: activityCategories,
          },
        },
        {
          path: "/ams/payment-type",
          name: "PaymentType",
          component: () => import("../views/PaymentType/PaymentType.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "payments",
            displayName: "payment_type",
            icon: activityCategories,
          },
        },
        {
          path: "/ams/payment-type/:id",
          name: "ViewPaymentType",
          component: () => import("../views/PaymentType/ViewPaymentType.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "payments",
            displayName: "payment_type",

          },
        },
        {
          path: "/ams/payment-purpose",
          name: "PaymentPurpose",
          component: () => import("../views/PaymentPurpose/PaymentPurpose.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "payments",
            displayName: "payment_purpose",
            icon: activityCategories,
          },
        },
        {
          path: "/ams/payment-purpose/:id",
          name: "ViewPaymentPurpose",
          component: () => import("../views/PaymentPurpose/ViewPaymentPurpose.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "payments",
            displayName: "payment_purpose",

          },
        },
        {
          path: "/ams/transaction-type",
          name: "transactionTypes",
          component: () => import("../views/TransactionType/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "transaction_types",
            icon: activity,
          },
        },
        {
          path: "/ams/progress-status",
          name: "progressStatus",
          component: () => import("../views/ProgressStatus/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "progress_status",
            icon: activity,
          },
        },
        {
          path: "/ams/additional-field",
          name: "additionalFields",
          component: () => import("../views/AdditionalField/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "additional_fields",
            icon: activity,
          },
        },

        {
          path: "/ams/item-type",
          name: "itemTypes",
          component: () => import("../views/ItemType/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "inventory",
            displayName: "item_types",
            icon: inventory,
          },
        },
        {
          path: "/ams/item-type-group",
          name: "itemTypeGroup",
          component: () => import("../views/ItemTypeGroup/ItemTypeGroup.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "inventory",
            displayName: "Item Type Group",
            icon: inventory,
          },
        },
        {
          path: "/ams/item-type-group/:id",
          name: "itemTypeGroupView",
          component: () => import("../views/ItemTypeGroup/ViewItemTypeGroup.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "inventory",
            displayName: "Item Type Group",

          },
        },
        {
          path: "/ams/fleet",
          name: "fleet",
          component: () => import("../views/Fleet/Fleet.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "users",
            displayName: "fleet",
            icon: users,
          },
        },
        {
          path: "/ams/fleet/:id",
          name: "viewVehicle",
          component: () => import("../views/Fleet/ViewVehicle.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "users",
            displayName: "fleet",
          },
        },
        {
          path: "/ams/roles",
          name: "roles",
          component: () => import("../views/Roles/Roles.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "users",
            displayName: "roles",
            icon: users,
          },
        },
        {
          path: "/ams/roles/:id",
          name: "viewRole",
          component: () => import("../views/Roles/ViewRole.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "users",
            displayName: "roles",
          },
        },
        {
          path: "/ams/activity-type-roles/:id",
          name: "viewActivityTypeRoles",
          component: () => import("../views/Roles/ViewActivityTypeRole.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "orders",
            displayName: "roles",
          },
        },

        {
          path: "/ams/customers",
          name: "customers",
          component: () => import("../views/Customers/Customers.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "customers",
            icon: customers,
          },
        },
        {
          path: "/ams/customers/:id",
          name: "viewCustomer",
          props: true,
          component: () => import("../views/Customers/ViewCustomer.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "customers",
            displayName: "customers",
          },
        },

        {
          path: "/ams/crm",
          name: "crmTasks",
          component: () => import("../views/Asset/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "crm_tasks",
            icon: customers,
          },
        },
        {
          path: "/ams/crm-schedule",
          name: "crmSchedule",
          component: () => import("../views/CrmSchedule/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "crm_schedule",
            icon: customers,
          },
        },
        {
          path: "/ams/crm-activity-health",
          name: "Health",
          component: () => import("../views/ActivityHealth/Health.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "crm_activity_health",
            icon: customers,
          },
        },
        {
          path: "/ams/crm-activity-health/:id",
          name: "Health",
          component: () => import("../views/ActivityHealth/ViewHealth.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "customers",
            displayName: "crm_activity_health",

          },
        },
        {
          path: "/ams/crm-opportunity-types",
          name: "crmOpportunityType",
          component: () => import("../views/CrmOpportunityTypes/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "crm_opportunity_type",
            icon: customers,
          },
        },
        {
          path: "/ams/customer-additional-field",
          name: "AdditionalFields",
          component: () => import("../views/AdditionalField/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "additional_fields",
          },
        },
        {
          path: "/ams/customer-agents",
          name: "customerAgents",
          component: () => import("../views/CustomerAgents/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "customer_agents",
            icon: customers,
          },
        },
        {
          path: "/ams/crm/:id",
          name: "crmView",
          component: () => import("../views/Asset/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "customers",
            displayName: "crm_tasks",
          },
        },

        {
          path: "/ams/request-categories",
          name: "requestCategories",
          component: () => import("../views/RequestCategory/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "request_categories",
            icon: customers,
          },
        },
        {
          path: "/ams/customer-segments",
          name: "customerSegments",
          component: () => import("../views/CustomerSegment/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "customer_segments",
            icon: customers,
          },
        },
        {
          path: "/ams/customer-group",
          name: "customerGroups",
          component: () => import("../views/CustomerGroup/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "customer_groups",
            icon: customers,
          },
        },
        {
          path: "/ams/interaction-types",
          name: "interactionTypes",
          component: () => import("../views/InteractionType/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "interaction_types",
            icon: customers,
          },
        },
        {
          path: "/ams/auditlogs",
          name: "auditLogs",
          component: () => import("../views/AuditLogs/AuditLogs.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "reports",
            displayName: "audit_logs",
            icon: reports,
          },
        },
        {
          path: "/ams/settings/company",
          name: "companySettings",
          component: () => import("../views/Settings/CompanySettings.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "settings",
            displayName: "company_settings",
            icon: settings,
          },
        },

        {
          path: "/ams/settings/asset-frequency",
          name: "assetFrequencies",
          component: () =>
            import("../views/Settings/AssetFrequencySettings.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "settings",
            displayName: "asset_frequencies",
            icon: settings,
          },
        },

        {
          path: "/ams/settings/unit-measure",
          name: "unitMeasures",
          component: () => import("../views/Settings/UnitMeasureSettings.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "settings",
            displayName: "unit_measures",
            icon: settings,
          },
        },

        {
          path: "/ams/settings/company-notes",
          name: "companyNotes",
          component: () => import("../views/Settings/CompanyNotes.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "settings",
            displayName: "company_notes",
            icon: settings,
          },
        },

        {
          path: "/ams/settings/default-role",
          name: "defaultRole",
          component: () => import("../views/Settings/DefaultRole.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "settings",
            displayName: "default_role",
            icon: settings,
          },
        },

        {
          path: "/ams/settings/task-types",
          name: "taskTypes",
          component: () => import("../views/Settings/TaskTypes.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "settings",
            displayName: "task_types",
            icon: settings,
          },
        },

        {
          path: "/ams/settings/email-parts",
          name: "emailParts",
          component: () => import("../views/Settings/EmailParts.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "settings",
            displayName: "email_parts",
            icon: settings,
          },
        },
        {
          path: "/ams/settings/company-policy",
          name: "companyPolicy",
          component: () => import("../views/Settings/CompanyPolicy.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "settings",
            displayName: "company_policy",
            icon: settings,
          },
        },

        {
          path: "/ams/settings/crm-settings",
          name: "crmSettings",
          component: () => import("../views/Settings/CrmSettings.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "settings",
            displayName: "crm_settings",
            icon: settings,
          },
        },
        {
          path: "/ams/bill-payment-to",
          name: "billPaymentTo",
          component: () => import("../views/BillPaymentTo/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "bill_payments",
            displayName: "bill_payment_to",
            icon: inventory,
          },
        },
        {
          path: "/ams/rpa-templates",
          name: "rpaTemplates",
          component: () => import("../views/RpaTemplates/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "bill_payments",
            displayName: "rpa_templates",
            icon: inventory,
          },
        },
        {
          path: "/ams/rpa-tasks",
          name: "rpaTasks",
          component: () => import("../views/RpaTasks/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "bill_payments",
            displayName: "rpa_tasks",
            icon: inventory,
          },
        },
        {
          path: "/ams/bill-payment-email-senders",
          name: "billPaymentEmailSenders",
          component: () => import("../views/BillPaymentEmailSenders/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "bill_payments",
            displayName: "bill_payment_email_senders",
            icon: inventory,
          },
        },
        {
          path: "/ams/bill-payment-email-subject-lines",
          name: "billPaymentEmailSubjectLines",
          component: () => import("../views/BillPaymentEmailSubjectLines/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "bill_payments",
            displayName: "bill_payment_email_subject_lines",
            icon: inventory,
          },
        },
        {
          path: "/ams/settings/language-settings",
          name: "LanguageSettings",
          component: () => import("../views/Settings/LanguageSettings.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "settings",
            displayName: "language_settings",
            icon: settings,
          },
        },
        {
          path: "/ams/assets",
          name: "assets",
          component: () => import("../views/Asset/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "asset_maintenance",
            displayName: "assets",
            icon: assets,
          },
        },
        {
          path: "/ams/asset-schedule",
          name: "assetSchedule",
          component: () => import("../views/CrmSchedule/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "asset_maintenance",
            displayName: "asset_schedule",
            icon: assets,
          },
        },
        {
          path: "/ams/assets/:id",
          name: "assetView",
          component: () => import("../views/Asset/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "asset_maintenance",
            displayName: "assets",
          },
        },

        {
          path: "/ams/asset-type",
          name: "assetTypes",
          component: () => import("../views/AssetType/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "asset_maintenance",
            displayName: "asset_types",
            icon: assets,
          },
        },
        {
          path: "/ams/asset-vendor",
          name: "assetVendors",
          component: () => import("../views/AssetVendor/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "asset_maintenance",
            displayName: "asset_vendors",
            icon: assets,
          },
        },
        {
          path: "/ams/locations",
          name: "locations",
          component: () => import("../views/Location/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "orders",
            displayName: "locations",
            icon: activity,
          },
        },
        {
          path: "/ams/locations/:id",
          name: "locationView",
          component: () => import("../views/Location/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "orders",
            displayName: "locations",
          },
        },


        {
          path: "/ams/inventory-transfer",
          name: "inventoryTransfer",
          component: () => import("../views/InventoryTransfer/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "inventory",
            displayName: "inventory_transfer",
            icon: inventory,
          },
        },
        {
          path: "/ams/transfer-section-items/",
          name: "inventoryTransfer-transfer",
          component: () => import("../views/InventoryTransfer/Transfer.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "inventory",
            subPath: "/ams/section-items",
          },
        },
        {
          path: "/ams/inventory-usage",
          name: "inventoryUsage",
          component: () => import("../views/InventoryUsage/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "inventory",
            displayName: "inventory_usage",
            icon: inventory,
          },
        },
        {
          path: "/ams/master-items",
          name: "masterItems",
          component: () => import("../views/MasterItem/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "inventory",
            displayName: "master_items",
            icon: inventory,
          },
        },

        {
          path: "/ams/master-items/:id",
          name: "masterItemView",
          component: () => import("../views/MasterItem/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            activeGroup: "inventory",
            displayName: "master_items",
          },
        },


        //////////reviews

        //////////review type
        {
          path: "/ams/review-types",
          name: "reviewTypes",
          component: () => import("../views/CheckoffTypes/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "review",
            displayName: "review_types",
            icon: reviews,
          },
        },
        ////review template
        {
          path: "/ams/review-templates",
          name: "reviewTemplates",
          component: () => import("../views/CheckoffTemplates/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "review",
            displayName: "review_templates",
            icon: reviews,
          },
        },
        /////////////////////////
        {
          path: "/ams/test",
          name: "test",
          component: () => import("../views/Test.vue"),
          meta: { requiresAuth: true, requiresAdmin: true },
        },
        // {
        //     path: '/ams/analytics',
        //     name: 'Analytics',
        //     component: () => import('../views/Analytics.vue'),
        //     meta: {
        //         requiresAuth: true,
        //         requiresAdmin: true,
        //         group: 'analytics',displayName:'',
        //         icon: graphUp
        //     },
        // },
        {
          path: "/ams/maps",
          name: "maps",
          component: () => import("../views/Maps/index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "analytics",
            displayName: "maps",
            icon: graphUp,
          },
        },
        {
          path: "/ams/ratings",
          name: "ratings",
          component: () => import("../views/Ratings/index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "analytics",
            displayName: "ratings",
            icon: graphUp,
          },
        },
        {
          path: "/ams/activity-analysis",
          name: "activityAnalysis",
          component: () => import("../views/ActivityAnalysis/index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "analytics",
            displayName: "activity_analysis",
            icon: graphUp,
          },
        },
        {
          path: "/ams/scheduling",
          name: "scheduling",
          component: () => import("../views/Scheduling/index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "analytics",
            displayName: "scheduling",
            icon: graphUp,
          },
        },
        {
          path: "/ams/due-invoices",
          name: "invoices",
          component: () => import("../views/DueInvoicesTest.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "integration",
            displayName: "invoices",
            icon: integration,
          },
        },
        {
          path: "/ams/lifecycle-stages",
          name: "lifecyleStages",
          component: () => import("../views/LifecycleStage/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "customers",
            displayName: "lifecycle_stages",
            icon: customers,
          },
        },
        {
          path: "/ams/quickbook-setup",
          name: "quickbook",
          component: () => import("../views/QuickbookSetup.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "integration",
            displayName: "quickbook",
            icon: integration,
          },
        },
        {
          path: "/ams/report-editor",
          name: "reportEditor",
          component: () => import("../views/ReportEditor.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "integration",
            displayName: "reportEditor",
            icon: editor,
          },
        },
        {
          path: "/ams/email-scheduler",
          name: "emailScheduler",
          component: () => import("../views/EmailScheduler/Index.vue"),
          meta: {
            requiresAuth: true,
            requiresAdmin: true,
            group: "integration",
            displayName: "email_scheduler",
            icon: editor,
          },
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  console.log("route to", to);
  i18n && (i18n.locale = localStorage.getItem("language") || "en");

  // Set a global meta tag for the entire application
  // Vue.meta().addMeta('httpEquiv', 'Content-Security-Policy')
  // Vue.meta().addMeta('content', "frame-ancestors 'none'")

  let redirectedToProfile = false;

  const userData = store.state.user || {};
  if (
    userData &&
    userData.is_first_time_login == 1 &&
    userData.is_customer_user == 0 &&
    to.path !== "/ams/profile" &&
    !redirectedToProfile
  ) {
    redirectedToProfile = true;
    next("/ams/profile");
  } else {
    if (store.getters.authenticated && store.state.isAdmin) {
      console.log(
        "store.getters.authenticated",
        store.getters.authenticated,
        store.state.isAdmin
      );
      if (to.matched.some((x) => x.meta.requiresAdmin && x.meta.requiresAuth)) {
        next();
      } else if (to.matched.some((x) => !x.meta.requiresAdmin && !x.meta.requiresAuth)) {
        console.log("to login-", from, to);
        next();
      } else {
        console.log("yes from-", from, to);
        if (
          from.query._redirect &&
          from.query._redirect != "" &&
          from.query._redirect != "/"
        ) {
          next(from.query._redirect);
        } else {
          next("/ams/dashboard");
        }
      }
    } else if (store.getters.authenticated) {
      if (
        to.matched.some((x) => !x.meta.requiresAdmin && x.meta.requiresAuth)
      ) {
        next();
      } else {
        next("/customer-portal/service-requests");
      }
    } else {
      if (to.matched.some((x) => !x.meta.requiresAuth)) {
        next();
      } else {
        console.log("from--", from, to);
        if (to.name == "") {
          next("/login");
        } else {
          next(`/login?_redirect=${to.fullPath}`);
        }
      }
    }
  }
});

export default router;
